import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const OrgRegistryBasicInfoComponent = ({ deliveryPreference,accountType,id, selectedOrgRegistry, shippingTypes, shippingProviders, accounts, fetchAcount, orgRegistry, onFormChange }: any) => {
 
    const dayEnum: any = [
        { Description: 'Sunday', Value: 1 },
        { Description: 'Monday', Value: 2 },
        { Description: 'Tuesday', Value: 3 },
        { Description: 'Wednesday', Value: 4 },
        { Description: 'Thursday', Value: 5 },
        { Description: 'Friday', Value: 6 },
        { Description: 'Saturday', Value: 7 }
      ]
      const timeSlots = [
        {
          Disabled: false,
          Selected: false,
          Text: '10 AM to 12 PM',
          Description: '10 AM to 12 PM',
          Value: 10
        },
        {
          Disabled: false,
          Selected: false,
          Text: '12 PM to 2 PM',
          Description: '12 PM to 2 PM',
          Value: 20
        },
        {
          Disabled: false,
          Selected: false,
          Text: '2 PM to 4 PM',
          Description: '2 PM to 4 PM',
          Value: 30
        },
        {
          Disabled: false,
          Selected: false,
          Text: '4 PM to 6 PM',
          Description: '4 PM to 6 PM',
          Value: 40
        },
        {
          Disabled: false,
          Selected: false,
          Text: '24 Hrs',
          Description: '24 Hrs',
          Value: 50
        }
      ]
    return(
        <>
<AccordionContainer
          child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
              <InputContainer
                label="Account Type"
                labelField="Text"
                list={accountType}
                onValueChange={(event: any, newValue: any) => {
                  fetchAcount(event.target.value);
                  onFormChange({
                    value: event.target.value,
                    field: 'AccountTypeId'
                  });
                } }
                optionName='Choose AccountType'
                type="select"
                value={orgRegistry?.AccountTypeId}
                valueField="Value" />
        
            {orgRegistry?.AccountTypeId
              ? <InputContainer
                  label="Account Name"
                  labelField="Name"
                  list={accounts}
                  onValueChange={(event: any, newValue: any) => {
                    onFormChange({
                      value: event.target.value,
                      field: 'AccountId'
                    });
                  } }
                  optionName='Choose Account'
                  type="select"
                  value={orgRegistry?.AccountId}
                  valueField="Id" />

              
              : null}

           <InputContainer
                label="Accept Order By Default Enabled"
                name="IsAcceptOrderByDefaultEnabled"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event,
                    field: 'IsAcceptOrderByDefaultEnabled'
                  });
                } }
                type="checkbox"
                value={orgRegistry?.IsAcceptOrderByDefaultEnabled} />
            <InputContainer
                label="Direct Shipment Enabled"
                name="IsDirectShipmentEnabled"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event,
                    field: 'IsDirectShipmentEnabled'
                  });
                } }
                type="checkbox"
                value={orgRegistry?.IsDirectShipmentEnabled} />
           <InputContainer
                label="UkId"
                name="UkId"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'UkId'
                  });
                } }
                type="text"
                value={orgRegistry?.UkId} />
           <InputContainer
                label="Delivery Preference"
                labelField="Text"
                list={deliveryPreference}
                onValueChange={(event: any, newValue: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'Delivery_preference'
                  });
                } }
                optionName='Choose DeliveryPreference'
                type="select"
                value={orgRegistry?.Delivery_preference}
                valueField="Text" />
          
            {orgRegistry?.Delivery_preference === 'Network' && <div>
            <InputContainer
                label="LogisticProviderAccount Name" 
                labelField="AccountName"
                list={shippingProviders}
                onValueChange={(newValue: any) => {
                  const valueData: any = newValue.map((option: any) => option?.value || '');
                  onFormChange({
                    value: valueData,
                    field: 'PreferredLogisticProviderAccountIds'
                  });
                } }
                type="multiselect"
                valueField="AccountId"
                value={orgRegistry?.PreferredLogisticProviderAccountIds} />
            </div>}
             <InputContainer
                label="Shipping Type"
                labelField="ShippingTypeName"
                list={shippingTypes}
                onValueChange={(event: any, newValue: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'ShippingTypeId'
                  });
                } }
                optionName='Choose ShippingType'
                type="select"
                value={orgRegistry?.ShippingTypeId}
                valueField="Id" />
           <InputContainer
                label="GPS"
                name="gps"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'gps'
                  });
                } }
                type="text"
                value={selectedOrgRegistry?.gps} />
            <InputContainer
                label="Radius Unit"
                name="unit"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'unit'
                  });
                } }
                type="text"
                value={selectedOrgRegistry?.unit} />
          <InputContainer
                label="Radius Value"
                name="value"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'value'
                  });
                } }
                type="text"
                value={selectedOrgRegistry?.value} />
           <div>   <InputContainer
                  label="Days" 
                  labelField="Description"
                  list={dayEnum}
                  onValueChange={(newValue: any ) => {
                  const valueData: any = newValue.map((option: any) => option?.value || '');
                  onFormChange({
                    value: valueData,
                    field: 'days'
                  });
                } }
                type="multiselect"
                 valueField="Value"
                value={selectedOrgRegistry?.days} />

</div>
            <div>
            <InputContainer
               label="Holidays" 
                labelField="Description"
                 list={dayEnum}
                onValueChange={(newValue: any ) => {
                  const valueData: any = newValue.map((option: any) => option?.value || '');
                  onFormChange({
                    value: valueData,
                    field: 'holidays'
                  });
                } }
                type="multiselect"
                valueField="Description"
                value={selectedOrgRegistry?.holidays} />

</div>
           
              <InputContainer
                label="Frequency"
                name="frequency"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'frequency'
                  });
                } }
                type="text"
                value={selectedOrgRegistry?.frequency} />
           <div>
           <InputContainer
                label="Times" 
                 labelField="Description"
                 list={timeSlots}
                 onValueChange={( newValue: any) => {
                  const valueData: any = newValue.map((option: any) => option?.value || '');
                  onFormChange({
                    value: valueData,
                    field: 'times'
                  });
                } }
                type="multiselect"
                valueField="Description"
                value={selectedOrgRegistry?.times} />

</div>
              <InputContainer
                label="Range Start"
                name="start"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'start'
                  });
                } }
                type="text"
                value={selectedOrgRegistry?.start} />
             <InputContainer
                label="Range End"
                name="end"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'end'
                  });
                } }
                type="text"
                value={selectedOrgRegistry?.end} />
            <InputContainer
                label="Currently Servicing"
                name="CurrentlyServicing"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event,
                    field: 'CurrentlyServicing'
                  });
                } }
                type="checkbox"
                value={orgRegistry?.CurrentlyServicing} />
            <InputContainer
                label="Use Settings From ConfigFile"
                name="UseSettingsFromConfigFile"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event,
                    field: 'UseSettingsFromConfigFile'
                  });
                } }
                type="checkbox"
                value={orgRegistry?.UseSettingsFromConfigFile} />
          
            {id !== '0' &&
               <InputContainer
                  isDisabled
                  label="OrganizationUnit Name"
                  name="OrganizationUnit Name"
                  onValueChange={(event: any) => {
                    onFormChange({
                      value: event.target.value,
                      field: 'OwnedByOUName'
                    });
                  } }
                  type="text"
                  value={orgRegistry?.OwnedByOUName} />

             }
            {id !== '0' &&
              <InputContainer
                  isDisabled
                  label="OrganizationUnit Name"
                  name="OrganizationUnit Name"
                  onValueChange={(event: any) => {
                    onFormChange({
                      value: event.target.value,
                      field: 'OwnedByOUAccountName'
                    });
                  } }
                  type="text"
                  value={orgRegistry?.OwnedByOUAccountName} />

             }
          </div>
          }
          expandedPanel="OrgRegistry"
          headerTitle="Org Registry" 
          />
        </>
)}
export default OrgRegistryBasicInfoComponent;
